export default "__VITE_ASSET__hi_5_E6V__"